import React from "react";
import { useLocation } from "react-router-dom";
import { useGetParentById } from "../../hooks/parentsHooks/useParents.hooks";
import Wrapper from "../../Components/Wrapper/wrapper";
import { Pageheader } from "../../Constants/pageheader";
import { ParentNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { ParentInfo } from "../../Components/parents/ParentInfo";
import { ParentStudent } from "../../Components/parents/ParentsStudent";

export const ParentDetailsPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const section = searchParams.get("section");
  const parentId = searchParams.get("parentId") || "";
  const parsedParentId = parseInt(parentId, 10);

  const { isLoading: isParentLoading, data: parentDetail } = useGetParentById({
    parentId: parsedParentId,
  });

  if (isParentLoading) return <div />;

  return (
    <Wrapper
      header={Pageheader.ParentDetails}
      headerNavigation={[
        {
          text: "Parent info",
          section: ParentNavigationHeader.PARENT_INFO,
        },
        {
          text: "Student",
          section: ParentNavigationHeader.STUDENT,
        },
      ]}
    >
      {section === ParentNavigationHeader.PARENT_INFO ? (
        <ParentInfo parent={parentDetail} />
      ) : (
        <></>
      )}
      {section === ParentNavigationHeader.STUDENT ? (
        <ParentStudent parent={parentDetail} />
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
